import { useEffect } from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import CookieBanner from "@/components/CookieBanner";
import AnalyticsTracker from "@/components/AnalyticsTracker";
import GoogleAnalytics from "@/components/GoogleAnalytics";
import MetaPixel from "@/components/MetaPixel";
import { WhatsAppFloat } from "@/components/WhatsAppFloat";
import Home from "@/pages/Home";
import ArticlePage from "@/pages/ArticlePage";
import Admin from "@/pages/Admin";
import LandingPage from "@/pages/LandingPage";
import NotFound from "@/pages/NotFound";
import PrivacyPage from "@/pages/PrivacyPage";
import { PRIVACY_URL } from "@/data/content";

const ScrollManager = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.__lenis?.scrollTo(0, { immediate: true });
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

const legacyHashes = [
  ["vantaggi", "#vantaggi"],
  ["blog", "#blog"],
  ["news", "#blog"],
  ["chi-siamo", "#chi-siamo"],
  ["contatti", "#contatti"],
  ["faq", "#faq"],
  ["trasparenza", "#trasparenza"],
];

const LegacyRedirect = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const path = pathname.toLowerCase();
    if (path.includes("privacy")) {
      window.location.replace(PRIVACY_URL);
      return;
    }
    const blogMatch = path.match(/^\/it\/blog\/[^/]+\/([a-z0-9-]+)\/?$/);
    if (blogMatch) {
      window.location.replace(`/blog/${blogMatch[1]}`);
      return;
    }
    for (const [key, hash] of legacyHashes) {
      if (path.includes(key)) {
        window.location.replace(`/${hash}`);
        return;
      }
    }
    window.location.replace("/");
  }, [pathname]);
  return null;
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 0.95 });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="grain min-h-screen">
      <BrowserRouter>
        <ScrollManager />
        <AnalyticsTracker />
        <GoogleAnalytics />
        <MetaPixel />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/blog/:slug" element={<ArticlePage />} />
          <Route path="/a/:slug" element={<ArticlePage />} />
          <Route path="/l/:lpSlug" element={<LandingPage />} />
          <Route path="/affitta-con-noi" element={<LandingPage slug="affitta-con-noi" />} />
          <Route path="/registrazione-contratto-affitto" element={<LandingPage slug="registrazione-contratto-affitto" />} />
          <Route path="/affitto-garantito" element={<LandingPage slug="affitto-garantito" />} />
          <Route path="/canone-concordato-firenze" element={<LandingPage slug="canone-concordato-firenze" />} />
          <Route path="/verifica-solvibilita-inquilino" element={<LandingPage slug="verifica-solvibilita-inquilino" />} />
          <Route path="/assicurazione-morosita" element={<LandingPage slug="assicurazione-morosita" />} />
          <Route path="/affitti-scandicci" element={<LandingPage slug="affitti-scandicci" />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/it/*" element={<LegacyRedirect />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      <WhatsAppFloat />
      </BrowserRouter>
      <CookieBanner />
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
